import mapi from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

/** Läuft in Capacitor iOS/Android (nicht im Browser). */
export function isNativeApp() {
  try {
    return !!(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function'
      && window.Capacitor.isNativePlatform());
  } catch (_e) {
    return false;
  }
}

export function nativePlatform() {
  try {
    const p = window.Capacitor?.getPlatform?.();
    if (p === 'ios' || p === 'android') return p;
  } catch (_e) { /* ignore */ }
  return null;
}

async function enableNativePush() {
  const { PushNotifications } = await import('@capacitor/push-notifications');
  const platform = nativePlatform();
  if (!platform) throw new Error('Unbekannte native Plattform');

  let perm = await PushNotifications.checkPermissions();
  if (perm.receive === 'prompt' || perm.receive === 'prompt-with-rationale') {
    perm = await PushNotifications.requestPermissions();
  }
  if (perm.receive !== 'granted') {
    throw new Error('Benachrichtigungen wurden nicht erlaubt');
  }

  return new Promise((resolve, reject) => {
    const clean = () => {
      PushNotifications.removeAllListeners().catch(() => {});
    };
    PushNotifications.addListener('registration', async (token) => {
      try {
        await mapi.post('/app/push/device', { token: token.value, platform });
        clean();
        resolve(true);
      } catch (e) {
        clean();
        reject(e);
      }
    });
    PushNotifications.addListener('registrationError', (err) => {
      clean();
      reject(new Error(err?.error || 'Push-Registrierung fehlgeschlagen'));
    });
    PushNotifications.register().catch((e) => {
      clean();
      reject(e);
    });
  });
}

async function enableWebPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('Push wird auf diesem Gerät nicht unterstützt');
  }
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Benachrichtigungen wurden nicht erlaubt');
  const reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  const { data } = await mapi.get('/app/push/vapid-public-key');
  if (!data.key) throw new Error('Push serverseitig nicht konfiguriert');
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.key),
    });
  }
  await mapi.post('/app/push/subscribe', sub.toJSON());
  return true;
}

export async function enablePush() {
  if (isNativeApp()) return enableNativePush();
  return enableWebPush();
}
